import Component from '@glimmer/component';
import Select from 'tio-reimagined/components/select';
import { AVAILABLE_DATASETS } from '../utils/dataset-utils';

interface DatasetSelectorSignature {
  Args: {
    selectedDataset: string;
    onDatasetChange: (dataset: string) => void;
    disabled?: boolean;
  };
}

export default class DatasetSelector extends Component<DatasetSelectorSignature> {
  datasetOptions = AVAILABLE_DATASETS.map((dataset) => ({
    key: dataset.key,
    label: dataset.label,
  }));

  <template>
    <div class="shrink-0 min-w-[200px]" data-test-dataset-selector>
      <Select
        @items={{this.datasetOptions}}
        @selected={{@selectedDataset}}
        @onChange={{@onDatasetChange}}
        @size="sm"
        @placeholder="Select dataset"
      />
    </div>
  </template>
}
